import styled from 'styled-components';

export const Wrapper = styled.div`
    width: 100%;
    height: auto;
    ${p => p.width50 && `
        width: 50%;
        @media (max-width: 555px) {
            width: 100%;
        }
    `}
    .custom-select-container {
        display: inline-block;
        width: 100%;
        height: 48px;
        line-height: 35px;
        position: relative;
        color: black;
    }
    .input {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
    }
    .selected-text {
        background: #F4F4F4;
        padding: 0px 20px;
        height: 47px;
        height: 100%;
        border-radius: 10px;
        cursor: pointer;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;
        font-weight: 400;
        border: 1px solid #E5E7EB;
        @media (max-width: 600px) {
            font-size: 15px;
        }
        &:hover {
            border: 1px solid gray;
        }
        ${p => p.webConfig.dir === 'ltr' && `
            direction: ltr;
        `}
        ${p => p.freeTimeCalendar && `
            background: white;
            color: #0D2439;
            font-size: 14px;
            font-weight: 500;
            border-radius: 8px;
            cursor: pointer;
            padding: 0 8px;
            padding-right: 15px;
        `}
        ${p => p.webConfig.dir === 'ltr' && p.freeTimeCalendar && `
            padding-right: 10px;
            padding-left: 15px;
        `}
        .text {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            gap: 5px;
            ${p => p.freeTimeCalendar && `
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                border: 1px solid #29BCAB;
                height: 100%;
                border-radius: 8px;
                line-height: 48px;
                padding: 0 10px;
        `}  
        }
    }
    .icon {
        color: black;
        width: 20px;
        height: 20px;
        ${p => p.freeTimeCalendar && `
            width: 30px;
            height: 30px;
            color: #61788E;
        `}
    }
    .selected-text::after {
        content: "";
        position: absolute;
        right: 10px;
        top: 16px;
    }
    .selected-text.active::after {
        top: 8px;
    }
    ul {
        margin: 0px;
        margin-top: 10px;
        padding: 0;
        text-align: right;
        height: 300px;
        overflow: scroll;
        box-shadow: 0px 1px 8px rgba(0,0,0,0.25);
        border-radius: 10px;
        z-index: 999;
        background: white;
    } 
    .select-options {
        position: absolute;
        width: 100%;
    }
    li {
        list-style-type: none;
        padding: 5px 20px;
        background: white;
        cursor: pointer;
        color: #61788E;
        font-size: 16px;
        font-weight: 400;
        @media (max-width: 600px) {
            font-size: 15px;
        }
        ${p => p.webConfig.dir === 'ltr' && `
            text-align: left;
        `}
        ${p => p.freeTimeCalendar && `
            font-size: 14px;
            font-weight: 500;
        `}
    }
    li:hover {
        color: black;
        background-color: #F4F4F4;
        ${p => p.freeTimeCalendar && `
        `}
    }
    .selected {
        color: black;
        background-color: #F4F4F4;
        ${p => p.freeTimeCalendar && `
            background-color: white;
            background-color: #E9F7F5;
        `}
    }
      
`